import { render, staticRenderFns } from "./SiteColors.vue?vue&type=template&id=147cb18a"
import script from "./SiteColors.vue?vue&type=script&lang=js"
export * from "./SiteColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports